// extracted by mini-css-extract-plugin
module.exports = {"pageName":"ComplimentaryFood_pageName__1uts9"};